/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createLcm } from '../../factoriesNumber.js';
export var lcmDependencies = {
  typedDependencies,
  createLcm
};